import axios from '../../node_modules/axios';

const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  // baseURL: global_.BASE_URL,
  timeout: 120000,
  withCredentials: true //让ajax携带cookie
})
//请求拦截
service.interceptors.request.use(config => {
  return config;
}, error => {
  console.log(error);
  return Promise.reject();
})

//相应拦截
service.interceptors.response.use(
    response => {
      if (response.status === 200) {
          return response.data
      } else if(response.status === 413) {
             alert("文件过大");
      }else{
          Promise.reject();
      }
    }, error => {
      console.log(error);
      return Promise.reject();
    }
  )

export default {
  //get请求
  requestGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //get请求不带参数
  requestQuickGet(url) {
    return new Promise((resolve, reject) => {
      service.get(url).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post请求
  requestPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, params, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post请求--下载文件
  requestPostForm(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then(res => {
        resolve(res) //注意res是axios封装的对象，res.data才是服务端返回的信息
      }).catch(error => {
        reject(error)
      })
    })
  },
  //post请求--下载文件
  requestPostDownload(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: "arraybuffer"
      }).then(res => {
        resolve(res) //注意res是axios封装的对象，res.data才是服务端返回的信息
      }).catch(error => {
        reject(error)
      })
    })
  },
  //put请求
  requestPut(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.put(url, params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //delete请求
  requestDelete(url, params = {}) {
    return new Promise((resolve, reject) => {
      service.delete(url, params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //from表单上传文件
    requestPostUploadFile(url, params = {}) {
        return new Promise((resolve, reject) => {
          service.post(url, params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      },
}



// WEBPACK FOOTER //
// ./src/utils/request.js